// This is a generated file!

import './arrow-drop-up-icon-sk';
